<template>
  <v-card :flat="flat" :color="card_color" max-width="500px" style='border-radius: 5px'>
    <v-card-text>
      <v-flex xs12 :class="['text-center', text_color]" >
        {{loadingText}}...
      </v-flex>
      <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
      <v-flex xs12 class="mt-2 text-center">
        <v-progress-circular :size="70" :width="7" :color="loading_color" indeterminate></v-progress-circular>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'cardLoading',
    props: {
      loadingText: {
        type: String,
        default: () => 'Carregando'
      },
      card_color:{
        type: String,
        default: () => 'primary'
      },
      text_color:{
        type: String,
        default: () => 'white--text'
      },
      loading_color:{
        type: String,
        default: () => 'white'
      },
      flat: {
        type: Boolean,
        default: false
      }
    },

  }
</script>

<style scoped>

</style>